import { useCallback, useEffect, useState } from 'react';
import { loadSetting, saveSetting } from '../utils/storage';

// The page loads the stored (or system) theme before React starts (public/index.html); this hook
// switches the PrimeReact stylesheet and the data-theme attribute that the app's own tokens follow.
function systemTheme() {
  try {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  } catch (e) {
    return 'light';
  }
}

function applyTheme(theme) {
  document.documentElement.setAttribute('data-theme', theme);
  const link = document.getElementById('theme-link');
  if (link) {
    link.href = `${process.env.PUBLIC_URL}/themes/lara-${theme}-teal/theme.css`;
  }
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) {
    meta.setAttribute('content', theme === 'dark' ? '#071426' : '#ffffff');
  }
}

export function useTheme() {
  const [theme, setTheme] = useState(() => {
    const stored = loadSetting('theme', null);
    return stored === 'dark' || stored === 'light' ? stored : systemTheme();
  });

  useEffect(() => applyTheme(theme), [theme]);

  const toggle = useCallback(() => {
    setTheme((current) => {
      const next = current === 'dark' ? 'light' : 'dark';
      saveSetting('theme', next);
      return next;
    });
  }, []);

  return [theme, toggle];
}
